/**
 * Cinematic Hero — scroll-scrub VIDEO (skill: cinematic-3d-product-pages)
 *
 * Single <video> with currentTime driven by scroll position.
 * Source re-encoded with -g 1 keyframe-every-frame so every seek is decode-cheap.
 * Drag also scrubs currentTime for manual rotation.
 */
// Build marker: forces Shopify to bump the v= asset hash.
// Without this, CDN serves the old minified hash even though
// the file content has been updated.
var CINEMATIC_BUILD_ID = "20260522T2030";

(function () {
  const SCRUB = 0.35;
  const MAP_START = 0.05;
  const MAP_END = 0.95;
  const MIN_BOOT_MS = 800;
  const OUTRO_VH = 0;
  const CROSS_AT = 0.9;
  const HERO_LOCK_RATIO = 0.97;
  /* Medju-sekcija: source-assets/rukavideo.mp4 → le-handoff.mp4 (ruka → saten). */
  const HANDOFF_VH = 240;
  const HANDOFF_MAT_BLEND = 0.1;
  const FIT_TAIL = 0.08;
  const HANDOFF_DURATION_FALLBACK = 7.041667;

  /* Priča forward: makro materijal → dodir → realnost na ulici.
     zoomFrom chapter 0 = 1.04 da se uklopi sa setFitPhase scale (1.04) — bez jump-a. */
  const MAT_CHAPTERS = [
    { scrollEnd: 0.4, v0: 0.0, v1: 0.4, label: "Materijal", zoomFrom: 1.04, zoomTo: 1.02 },
    { scrollEnd: 0.66, v0: 0.4, v1: 0.7, label: "Dodir", zoomFrom: 1.02, zoomTo: 1.0 },
    { scrollEnd: 1.0, v0: 0.7, v1: 1.0, label: "Realnost", zoomFrom: 1.0, zoomTo: 1.0 },
  ];

  function mapMatScrollToVideo(progress) {
    const p = Math.max(0, Math.min(1, progress));
    let prevScroll = 0;
    for (let i = 0; i < MAT_CHAPTERS.length; i++) {
      const ch = MAT_CHAPTERS[i];
      if (p <= ch.scrollEnd) {
        const span = ch.scrollEnd - prevScroll || 1;
        const local = (p - prevScroll) / span;
        return ch.v0 + local * (ch.v1 - ch.v0);
      }
      prevScroll = ch.scrollEnd;
    }
    return 1;
  }

  function getMatChapterState(progress) {
    const p = Math.max(0, Math.min(1, progress));
    let prevScroll = 0;
    for (let i = 0; i < MAT_CHAPTERS.length; i++) {
      const ch = MAT_CHAPTERS[i];
      if (p <= ch.scrollEnd) {
        const span = ch.scrollEnd - prevScroll || 1;
        const local = (p - prevScroll) / span;
        const zoom = ch.zoomFrom + local * (ch.zoomTo - ch.zoomFrom);
        return { idx: i, label: ch.label, zoom };
      }
      prevScroll = ch.scrollEnd;
    }
    const last = MAT_CHAPTERS[MAT_CHAPTERS.length - 1];
    return { idx: MAT_CHAPTERS.length - 1, label: last.label, zoom: last.zoomTo };
  }

  const html = document.documentElement;

  function parseConfig(section) {
    const el = section.querySelector("[data-hero-config]");
    if (!el) return { scrollHeightVh: 280, videoEnd: 1.0 };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { scrollHeightVh: 280, videoEnd: 1.0 };
    }
  }

  function lockScroll() {
    html.classList.add("le-3d-boot-lock");
  }

  function unlockScroll() {
    html.classList.remove("le-3d-boot-lock");
  }

  function fmtAngle(t, duration) {
    if (!duration) return "000\u00b0 / 360\u00b0";
    const deg = Math.round((t / duration) * 360) % 360;
    return String(deg).padStart(3, "0") + "\u00b0 / 360\u00b0";
  }

  function initHero(section) {
    if (section.dataset.heroInit === "1") return;
    section.dataset.heroInit = "1";

    const config = parseConfig(section);
    const track = section.querySelector("[data-track]");
    const pin = section.querySelector("[data-pin]");
    const rotatorWrap =
      section.querySelector("[data-hero-wrap]") ||
      section.querySelector("[data-rotator-wrap]");
    const heroWrap = rotatorWrap;
    const fitWrap = section.querySelector("[data-fit-wrap]");
    const handoffWrap = section.querySelector("[data-handoff-wrap]");
    const handoffVideo = section.querySelector("[data-cine-handoff-video]");
    const materialStage = section.querySelector("[data-material-stage]");
    const materialVideo = section.querySelector("[data-cine-material-video]");
    const cineBridge = section.querySelector("[data-cine-bridge]");
    const productStack = section.querySelector("[data-product-stack]");
    const materialSection = document.querySelector("[data-cinematic-material]");
    const video = section.querySelector("[data-hero-video]");
    const copy = section.querySelector("[data-copy]");
    const counter = section.querySelector("[data-frame-counter]");
    const scrollPip = section.querySelector("[data-scroll-pip]");
    const boot = section.querySelector("[data-boot]");
    const bootFill = section.querySelector("[data-boot-fill]");
    const bootPct = section.querySelector("[data-boot-pct]");
    const headingStages = section.querySelectorAll("[data-heading-stages] .ch__heading-stage");
    const hotspots = section.querySelectorAll("[data-hotspot]");
    const detailPanel = section.querySelector("[data-detail]");
    const detailClose = section.querySelector("[data-detail-close]");
    const detailTitleEl = section.querySelector("[data-detail-title]");
    const detailTextEl = section.querySelector("[data-detail-text]");

    if (!track || !pin || !video) return;

    const unifiedRoot = document.querySelector("[data-cine-unified]");
    const fitSection = document.querySelector("[data-cinematic-fit]");
    const anglesSection = document.querySelector("[data-cinematic-angles]");
    const revealSection = document.querySelector("[data-cinematic-reveal]");
    const dropSection = document.querySelector("[data-cinematic-drop]");
    const isUnified = !!(unifiedRoot && fitSection);
    let fitVh = 260;
    let anglesVh = 540;
    let revealVh = 280;
    let dropVh = 110;
    let materialVh = 300;
    if (isUnified && fitSection) {
      const fitCfgEl = fitSection.querySelector("[data-fit-config]");
      if (fitCfgEl) {
        try {
          fitVh = JSON.parse(fitCfgEl.textContent).scrollHeightVh || 260;
        } catch (e) {
          fitVh = 260;
        }
      }
      fitSection.classList.add("cf--unified");
      const fitTrack = fitSection.querySelector("[data-track]");
      if (fitTrack) {
        fitTrack.style.setProperty("--scroll-vh", "0");
        fitTrack.style.height = "0";
      }
    }
    if (isUnified && anglesSection) {
      const angCfgEl = anglesSection.querySelector("[data-angles-config]");
      if (angCfgEl) {
        try {
          const angCfg = JSON.parse(angCfgEl.textContent);
          anglesVh = angCfg.scrollHeightVh || 540;
          revealVh = angCfg.revealScrollHeightVh || revealVh;
        } catch (e) {
          anglesVh = 540;
        }
      }
      anglesSection.classList.add("cag--unified");
      const angTrack = anglesSection.querySelector("[data-track]");
      if (angTrack) {
        angTrack.style.setProperty("--scroll-vh", "0");
        angTrack.style.height = "0";
      }
    } else {
      anglesVh = 0;
    }
    if (isUnified && revealSection) {
      /* revealVh dolazi iz angles config (revealScrollHeightVh), ne iz reveal sekcije */
      revealSection.classList.add("cvr--unified");
      const revTrack = revealSection.querySelector("[data-track]");
      if (revTrack) {
        revTrack.style.setProperty("--scroll-vh", "0");
        revTrack.style.height = "0";
      }
    } else {
      revealVh = 0;
    }
    if (isUnified && dropSection) {
      const dropCfgEl = dropSection.querySelector("[data-drop-config]");
      if (dropCfgEl) {
        try {
          dropVh = JSON.parse(dropCfgEl.textContent).scrollHeightVh || 110;
        } catch (e) {
          dropVh = 110;
        }
      }
      dropSection.classList.add("cdp--unified");
      const dropTrack = dropSection.querySelector("[data-track]");
      if (dropTrack) {
        dropTrack.style.setProperty("--scroll-vh", "0");
        dropTrack.style.height = "0";
      }
    } else {
      dropVh = 0;
    }
    if (isUnified && materialSection) {
      const matCfgEl = materialSection.querySelector("[data-material-config]");
      if (matCfgEl) {
        try {
          materialVh = JSON.parse(matCfgEl.textContent).scrollHeightVh || 300;
        } catch (e) {
          materialVh = 300;
        }
      }
      materialSection.classList.add("cm--unified");
      const matTrack = materialSection.querySelector("[data-track]");
      if (matTrack) {
        matTrack.style.setProperty("--scroll-vh", "0");
        matTrack.style.height = "0";
      }
    }

    const scrubVh = config.scrollHeightVh;
    /* hero + fit + angles (9+ponovljeni front) + reveal (vvvvv video). */
    materialVh = 0;
    const handoffVh = 0;
    const totalVh = isUnified
      ? scrubVh + fitVh + anglesVh + revealVh + dropVh
      : scrubVh + OUTRO_VH;
    const heroShare = scrubVh / totalVh;
    const fitShare = isUnified ? fitVh / totalVh : 0;
    const anglesShare = isUnified ? anglesVh / totalVh : 0;
    const revealShare = isUnified ? revealVh / totalVh : 0;
    const dropShare = isUnified ? dropVh / totalVh : 0;
    const handoffShare = 0;
    const materialShare = 0;
    const fitEnd = heroShare + fitShare;
    const anglesEnd = fitEnd + anglesShare;
    const revealEnd = anglesEnd + revealShare;
    const dropEnd = revealEnd + dropShare;
    const handoffEnd = fitEnd;
    const scrubRatio = scrubVh / totalVh;
    const scrubEndPx = () => (scrubVh / 100) * window.innerHeight;
    const getHeroScrollP = (globalP) => {
      const frac = scrubVh / Math.max(totalVh, 1);
      if (globalP >= frac) return 1;
      return globalP / Math.max(frac, 0.0001);
    };

    track.style.setProperty("--scroll-vh", String(totalVh));

    /* Mobile URL-bar killer: on iOS Safari + mobile Chrome, the URL bar
       shows/hides during scroll, which changes the meaning of 1vh in real
       time. Because .ch__track height is in vh units, the track height
       silently grows/shrinks under the user's finger — that re-positions
       the pin's end and makes the page feel like it has no end (you scroll,
       it stretches, you scroll more, it stretches again). Lock the track to
       PIXELS at init using the initial innerHeight; from then on, no matter
       what the URL bar does, the scroll length is fixed. Only do this on
       touch devices so desktop keeps the responsive vh behavior. */
    if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
      const lockedTrackHeightPx = Math.round((totalVh / 100) * window.innerHeight);
      track.style.height = lockedTrackHeightPx + "px";
    }

    const fitVideo = section.querySelector("[data-fit-video]");
    const chrome = pin
      ? pin.querySelectorAll(
          ".ch__topbar, .ch__copy, .ch__edge, .ch__depth, .ch__hairline, .ch__hint, .ch__spotlight, .ch__bracket"
        )
      : [];
    let fitDuration = 0;
    if (fitVideo) {
      const onFitMeta = () => {
        fitDuration = fitVideo.duration || 0;
      };
      if (fitVideo.readyState >= 1 && fitVideo.duration) onFitMeta();
      else fitVideo.addEventListener("loadedmetadata", onFitMeta, { once: true });
    }
    let matDuration = 0;
    if (materialVideo) {
      const onMatMeta = () => {
        matDuration = materialVideo.duration || 0;
        /* Decode i drži frame 0 — tako materialStage nikad nije transparent
           kad fit-phase tail počne crossfade. Inače bi se videla crna pozadina. */
        try { materialVideo.currentTime = 0.05; } catch (e) {}
      };
      if (materialVideo.readyState >= 1 && materialVideo.duration) onMatMeta();
      else materialVideo.addEventListener("loadedmetadata", onMatMeta, { once: true });
      /* Force-load video — preload="auto" ne dekodira frame, samo bufferuje. */
      try { materialVideo.load(); } catch (e) {}
    }
    let handoffDuration = 0;
    let handoffPrimed = false;
    let handoffTargetTime = 0;
    let handoffRafId = null;
    if (handoffVideo) {
      const onHandoffMeta = () => {
        handoffDuration = handoffVideo.duration || HANDOFF_DURATION_FALLBACK;
        try {
          handoffVideo.currentTime = 0.05;
        } catch (e) {
          /* ignore */
        }
      };
      if (handoffVideo.readyState >= 1 && handoffVideo.duration) onHandoffMeta();
      else handoffVideo.addEventListener("loadedmetadata", onHandoffMeta, { once: true });
      try {
        handoffVideo.load();
      } catch (e) {
        /* ignore */
      }
    }
    html.classList.add("le-3d-cinematic-scroll");
    document.body.classList.add("le-3d-staging-preview");

    /* Throttle currentTime updates through rAF — skill effects.md §1 */
    let targetTime = 0;
    let rafId = null;
    let duration = 0;
    let isDragging = false;
    let zoomedActive = null;

    const tickSeek = () => {
      rafId = null;
      if (!duration) return;
      if (Math.abs(video.currentTime - targetTime) > 0.008) {
        try { video.currentTime = targetTime; } catch (e) { /* ignore */ }
      }
    };

    const scheduleSeek = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(tickSeek);
    };

    const mapToTime = (p) => {
      const m = Math.max(0, Math.min(1, (p - MAP_START) / (MAP_END - MAP_START)));
      return m * config.videoEnd;
    };

    /* === Boot: wait until video ready === */
    lockScroll();
    const bootStart = performance.now();

    const onProgress = (loaded) => {
      const pct = Math.round(loaded * 100);
      if (bootFill) bootFill.style.width = pct + "%";
      if (bootPct) bootPct.textContent = pct + "%";
    };

    /* iOS Safari (and some Android browsers) won't render the first
       video frame until user interaction OR an actual play() call —
       so even after the boot screen hides, the hero video shows as a
       blank/black box until the user scrolls past the start. Forcing
       a muted play()+pause() right after boot decodes the first frame
       and seeds the video pipeline; subsequent currentTime seeks then
       paint correctly. Wrapped in catch since some browsers reject
       autoplay even when muted. */
    const primeHeroVideo = () => {
      if (!video) return;
      try {
        const p = video.play();
        if (p && typeof p.then === "function") {
          p.then(() => {
            try { video.pause(); } catch (e) {}
            try { video.currentTime = 0; } catch (e) {}
          }).catch(() => {
            /* play() rejected (autoplay policy) — try setting currentTime
               directly so at least the seek pipeline initializes. */
            try { video.currentTime = 0.05; } catch (e) {}
          });
        }
      } catch (e) {
        try { video.currentTime = 0.05; } catch (err) {}
      }
    };

    const finishBoot = () => {
      const elapsed = performance.now() - bootStart;
      const wait = Math.max(0, MIN_BOOT_MS - elapsed);
      setTimeout(() => {
        if (boot) boot.classList.add("is-hidden");
        primeHeroVideo();
        /* CRITICAL: pin trigger must be created BEFORE the user is allowed
           to scroll. Previously unlockScroll() ran first, then initScroll()
           — on mobile the user's finger is often already on the screen
           waiting, so a single touch in the gap between unlock and trigger
           creation let the hero element scroll off naturally (because the
           pin didn't exist yet to lock it). Result: hero "disappeared" as
           soon as scroll started even though all the other (event-driven)
           sections kept working. Swap the order + force a refresh so the
           pin is fully active the moment scroll is enabled. */
        initScroll();
        if (typeof ScrollTrigger !== "undefined") {
          try { ScrollTrigger.refresh(); } catch (e) { /* ignore */ }
        }
        unlockScroll();
        setTimeout(() => {
          if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
        }, 700);
      }, wait);
    };

    const onMeta = () => {
      duration = video.duration || 0;
      if (counter) counter.textContent = fmtAngle(0, duration);
      try { video.currentTime = 0; } catch (e) {}
    };

    if (video.readyState >= 1 && video.duration) onMeta();
    else video.addEventListener("loadedmetadata", onMeta, { once: true });

    const updateBootProgress = () => {
      try {
        if (!duration) return;
        let buffered = 0;
        for (let i = 0; i < video.buffered.length; i++) {
          buffered += video.buffered.end(i) - video.buffered.start(i);
        }
        onProgress(Math.min(1, buffered / duration));
      } catch (e) {}
    };

    video.addEventListener("progress", updateBootProgress);
    video.addEventListener("canplaythrough", () => {
      onProgress(1);
      finishBoot();
    }, { once: true });

    /* Fallback: uvek otključaj boot — inače crni ekran */
    setTimeout(() => {
      if (boot && !boot.classList.contains("is-hidden")) {
        onProgress(1);
        finishBoot();
      }
    }, 3000);

    /* === Drag scrub === */
    let startX = 0;
    let startTime = 0;

    rotatorWrap.addEventListener("pointerdown", (e) => {
      if (!duration) return;
      if (zoomedActive) return;
      if (e.target.closest("[data-hotspot]")) return;
      isDragging = true;
      startX = e.clientX;
      startTime = video.currentTime;
      rotatorWrap.classList.add("is-dragging");
      try { rotatorWrap.setPointerCapture(e.pointerId); } catch (_) {}
    });

    rotatorWrap.addEventListener("pointermove", (e) => {
      if (!isDragging || !duration) return;
      const dx = e.clientX - startX;
      const rect = rotatorWrap.getBoundingClientRect();
      const ratio = dx / rect.width;
      let next = startTime - ratio * duration;
      while (next < 0) next += duration;
      while (next > duration) next -= duration;
      targetTime = next;
      scheduleSeek();
      if (counter) counter.textContent = fmtAngle(targetTime, duration);
    });

    const endDrag = (e) => {
      isDragging = false;
      rotatorWrap.classList.remove("is-dragging");
      try { rotatorWrap.releasePointerCapture(e.pointerId); } catch (_) {}
    };

    rotatorWrap.addEventListener("pointerup", endDrag);
    rotatorWrap.addEventListener("pointercancel", endDrag);

    /* === GSAP scroll === */
    const initScroll = () => {
      if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        window.addEventListener("load", initScroll, { once: true });
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      section.dataset.cineLayer = "hero";

      const lockEndFrame = () => {
        if (!duration) return;
        targetTime = duration * HERO_LOCK_RATIO;
        scheduleSeek();
        if (counter) counter.textContent = fmtAngle(targetTime, duration);
      };

      const seekFit = (ratio) => {
        if (!fitVideo || !fitDuration) return;
        const t = Math.max(0, Math.min(1, ratio)) * fitDuration;
        try {
          fitVideo.currentTime = t;
        } catch (e) {
          /* ignore */
        }
      };

      const tickHandoffSeek = () => {
        handoffRafId = null;
        if (!handoffVideo) return;
        const dur =
          handoffDuration || handoffVideo.duration || HANDOFF_DURATION_FALLBACK;
        handoffDuration = dur;
        try {
          if (Math.abs(handoffVideo.currentTime - handoffTargetTime) > 0.008) {
            handoffVideo.currentTime = handoffTargetTime;
          }
        } catch (e) {
          /* ignore */
        }
      };

      const scheduleHandoffSeek = () => {
        if (handoffRafId !== null) return;
        handoffRafId = requestAnimationFrame(tickHandoffSeek);
      };

      const primeHandoff = () => {
        if (!handoffVideo || handoffPrimed) return;
        handoffPrimed = true;
        handoffVideo.removeAttribute("poster");
        const run = () => {
          try {
            handoffVideo.currentTime = 0.05;
          } catch (e) {
            /* ignore */
          }
          handoffVideo
            .play()
            .then(() => handoffVideo.pause())
            .catch(() => {});
        };
        if (handoffVideo.readyState >= 2) run();
        else handoffVideo.addEventListener("loadeddata", run, { once: true });
      };

      const seekHandoff = (ratio) => {
        if (!handoffVideo) return;
        const dur =
          handoffDuration || handoffVideo.duration || HANDOFF_DURATION_FALLBACK;
        handoffDuration = dur;
        handoffTargetTime = Math.max(0, Math.min(1, ratio)) * dur;
        if (ratio > 0.001) primeHandoff();
        scheduleHandoffSeek();
      };

      const pauseVideo = (el) => {
        if (!el) return;
        try {
          el.pause();
        } catch (e) {
          /* ignore */
        }
      };

      const applyCineLayer = (layer) => {
        section.dataset.cineLayer = layer;
        if (layer === "hero") {
          if (productStack) {
            productStack.style.display = "";
            productStack.style.opacity = "";
            productStack.style.visibility = "";
          }
          if (fitWrap) {
            fitWrap.style.display = "";
            fitWrap.style.opacity = "";
            fitWrap.style.visibility = "";
          }
          if (handoffWrap) {
            handoffWrap.style.display = "";
            handoffWrap.style.opacity = "";
            handoffWrap.style.visibility = "";
          }
          pauseVideo(fitVideo);
          pauseVideo(handoffVideo);
        } else if (layer === "fit") {
          if (productStack) {
            productStack.style.display = "";
            productStack.style.opacity = "";
            productStack.style.visibility = "";
          }
          if (fitWrap) fitWrap.style.display = "";
          if (handoffWrap) {
            handoffWrap.style.display = "";
            handoffWrap.style.visibility = "hidden";
          }
          pauseVideo(handoffVideo);
        } else if (layer === "fit-handoff") {
          if (productStack) {
            productStack.style.display = "";
            productStack.style.opacity = "";
            productStack.style.visibility = "";
          }
          if (fitWrap) fitWrap.style.display = "";
          if (handoffWrap) handoffWrap.style.display = "";
        } else if (layer === "handoff") {
          if (productStack) {
            productStack.style.display = "";
            productStack.style.opacity = "";
            productStack.style.visibility = "";
          }
          if (fitWrap) {
            fitWrap.style.display = "";
            fitWrap.style.visibility = "hidden";
          }
          if (handoffWrap) handoffWrap.style.display = "";
          pauseVideo(fitVideo);
        } else if (layer === "material") {
          if (productStack) productStack.style.display = "none";
          if (fitWrap) fitWrap.style.display = "none";
          if (handoffWrap) handoffWrap.style.display = "none";
          pauseVideo(fitVideo);
          pauseVideo(handoffVideo);
        }
      };

      const restoreHeroChrome = () => {
        applyCineLayer("hero");
        section.classList.add("ch--hero-active");
        section.classList.remove(
          "ch--fit-phase",
          "ch--outro",
          "ch--combined",
          "ch--fit-handoff-xfade",
          "ch--handoff-phase"
        );
        section.style.removeProperty("--fit-xfade");
        section.style.removeProperty("--handoff-xfade");
        section.style.removeProperty("--handoff-out");
        chrome.forEach((el) => {
          if (el.classList.contains("ch__bracket")) {
            el.style.opacity = "";
            return;
          }
          el.style.opacity = "1";
        });
        if (copy) {
          copy.classList.add("ch--copy-visible");
          gsap.set(copy, { opacity: 1, y: 0 });
        }
      };

      const resetStack = () => {
        applyCineLayer("hero");
        if (heroWrap) {
          heroWrap.style.opacity = "";
          gsap.set(heroWrap, { y: 0, scale: 1, clearProps: "transform" });
        }
        if (fitWrap) {
          fitWrap.style.display = "";
          fitWrap.style.opacity = "";
          fitWrap.style.visibility = "";
        }
        if (pin) pin.style.setProperty("--stage-dim", "0");
        section.classList.remove(
          "ch--fit-phase",
          "ch--outro",
          "ch--combined",
          "ch--material-phase",
          "ch--handoff-phase",
          "ch--mat-bridge",
          "ch--fit-handoff-xfade",
          "ch--pin-done"
        );
        section.style.removeProperty("--fit-xfade");
        section.style.removeProperty("--handoff-xfade");
        section.style.removeProperty("--handoff-out");
        if (cineBridge) {
          cineBridge.style.setProperty("--curtain-t", "0");
          cineBridge.style.setProperty("--card-t", "0");
        }
        if (materialStage) {
          materialStage.style.opacity = "";
          materialStage.style.visibility = "";
          materialStage.style.clipPath = "";
          materialStage.style.webkitClipPath = "";
        }
        if (fitWrap) fitWrap.style.filter = "";
        if (fitVideo) fitVideo.style.filter = "";
        if (materialVideo) materialVideo.style.filter = "";
        if (pin) pin.style.setProperty("--stage-warm", "0");
        window.dispatchEvent(
          new CustomEvent("le-cine-material", {
            detail: { active: false, progress: 0, bridging: false, t: 0 },
          })
        );
        restoreHeroChrome();
        window.dispatchEvent(
          new CustomEvent("le-cine-fit", { detail: { active: false, progress: 0 } })
        );
        window.dispatchEvent(
          new CustomEvent("le-cine-handoff", { detail: { active: false, progress: 0 } })
        );
      };

      let cinePhase = "hero";

      const crossfadeInPin = (crossP) => {
        const blend = Math.min(1, Math.max(0, crossP) / 0.45);
        section.dataset.cineLayer = blend > 0.001 ? "cross" : "hero";
        if (productStack) productStack.style.display = "";
        if (fitWrap) fitWrap.style.display = "";
        section.style.setProperty("--cross-hero-op", String(1 - blend));
        section.style.setProperty("--cross-fit-op", String(blend));
        seekFit(blend * 0.1);
      };

      const applyOutro = (crossP) => {
        const p = Math.max(0, Math.min(1, crossP));
        chrome.forEach((el) => {
          el.style.opacity = String(Math.max(0, 1 - p * 2.5));
        });
        section.classList.toggle("ch--outro", p > 0);
        if (isUnified) crossfadeInPin(p);
      };

      const setFitPhase = (fitP) => {
        const fp = Math.max(0, Math.min(1, fitP));
        cinePhase = "fit";
        section.classList.remove(
          "ch--hero-active",
          "ch--material-phase",
          "ch--handoff-phase",
          "ch--mat-bridge"
        );
        if (copy) copy.classList.remove("ch--copy-visible");
        section.classList.add("ch--fit-phase", "ch--outro");
        if (fitSection) fitSection.classList.remove("cf--past");
        if (materialSection) {
          materialSection.classList.remove("cm--past", "cm--live", "cm--bridging");
        }

        const tailStart = 1 - FIT_TAIL;
        const tailP = fp <= tailStart ? 0 : (fp - tailStart) / FIT_TAIL;
        const tailEase = tailP * tailP * (3 - 2 * tailP);
        const useHandoff = handoffShare > 0 && handoffVideo;
        const inHandoffXfade = useHandoff && tailEase > 0.001;

        if (inHandoffXfade) {
          applyCineLayer("fit-handoff");
          section.classList.add("ch--fit-handoff-xfade");
          const showHand = tailEase > 0.22;
          const fitOp = showHand ? 0 : Math.max(0, 1 - tailEase / 0.22);
          const handOp = showHand ? Math.min(1, (tailEase - 0.22) / 0.78) : 0;
          section.style.setProperty("--fit-xfade", String(fitOp));
          section.style.setProperty("--handoff-xfade", String(handOp));
          section.style.setProperty("--fit-layer-vis", fitOp > 0.02 ? "visible" : "hidden");
          section.style.setProperty(
            "--handoff-layer-vis",
            handOp > 0.02 ? "visible" : "hidden"
          );
          if (tailEase > 0.02 && fitVideo && fitDuration) {
            try {
              fitVideo.currentTime = fitDuration * HERO_LOCK_RATIO;
            } catch (e) {
              /* ignore */
            }
          }
          if (handOp > 0.02) {
            primeHandoff();
            seekHandoff(handOp * 0.18);
          }
        } else {
          applyCineLayer("fit");
          section.classList.remove("ch--fit-handoff-xfade");
          section.style.removeProperty("--fit-xfade");
          section.style.removeProperty("--handoff-xfade");
          section.style.removeProperty("--fit-layer-vis");
          section.style.removeProperty("--handoff-layer-vis");
        }

        if (useHandoff) {
          if (materialStage) {
            materialStage.style.opacity = "0";
            materialStage.style.visibility = "hidden";
          }
        } else {
          applyCineLayer("fit");
          if (materialStage) {
            materialStage.style.visibility = "visible";
            materialStage.style.opacity = String(tailEase);
            materialStage.style.clipPath = "none";
            materialStage.style.webkitClipPath = "none";
          }
          if (materialVideo) {
            materialVideo.style.transform = "scale(1.04)";
            materialVideo.style.objectPosition = "50% 50%";
            materialVideo.style.filter = "";
            if (tailEase < 0.001) seekMaterial(0);
            else seekMaterial(tailEase * 0.05);
          }
        }

        chrome.forEach((el) => {
          el.style.opacity = "0";
        });
        if (fitSection) fitSection.classList.add("cf--live", "cf--raspad-active");

        if (fitVideo) {
          fitVideo.style.transform = "";
          fitVideo.style.objectPosition = "";
          fitVideo.style.filter = "";
        }
        if (pin) pin.style.setProperty("--stage-dim", "0");
        if (cineBridge) {
          cineBridge.style.setProperty("--curtain-t", "0");
          cineBridge.style.setProperty("--card-t", "0");
        }

        const fitScrubActive = !inHandoffXfade || tailEase < 0.12;
        window.dispatchEvent(
          new CustomEvent("le-cine-fit", {
            detail: { active: fitScrubActive, progress: fp },
          })
        );
        if (useHandoff && inHandoffXfade) {
          const handOp = Math.min(1, Math.max(0, (tailEase - 0.22) / 0.78));
          window.dispatchEvent(
            new CustomEvent("le-cine-handoff", {
              detail: { active: handOp > 0.02, progress: handOp * 0.18 },
            })
          );
        } else if (useHandoff) {
          window.dispatchEvent(
            new CustomEvent("le-cine-handoff", { detail: { active: false, progress: 0 } })
          );
        }
        window.dispatchEvent(
          new CustomEvent("le-cine-material", {
            detail: {
              active: false,
              progress: 0,
              bridging: useHandoff ? false : tailEase > 0.001,
              t: useHandoff ? 0 : tailEase,
            },
          })
        );
      };

      const seekMaterial = (ratio) => {
        if (!materialVideo || !matDuration) return;
        const t = Math.max(0, Math.min(1, ratio)) * matDuration;
        try {
          materialVideo.currentTime = t;
        } catch (e) {
          /* ignore */
        }
      };

      const clearHandoffStyles = () => {
        section.classList.remove("ch--handoff-phase");
      };

      /* Sekcija 2.5 — rukavideo: CSS klasa + event za cinematic-handoff.js */
      const setHandoffPhase = (hP) => {
        const t = Math.max(0, Math.min(1, hP));
        cinePhase = "handoff";
        applyCineLayer("handoff");
        section.classList.remove(
          "ch--hero-active",
          "ch--fit-phase",
          "ch--material-phase",
          "ch--mat-bridge",
          "ch--fit-handoff-xfade"
        );
        section.classList.add("ch--outro", "ch--handoff-phase");
        section.style.removeProperty("--fit-xfade");
        section.style.removeProperty("--handoff-xfade");
        if (copy) copy.classList.remove("ch--copy-visible");
        chrome.forEach((el) => {
          el.style.opacity = "0";
        });
        if (fitSection) fitSection.classList.add("cf--past");
        if (materialSection) materialSection.classList.remove("cm--past");

        const matStart = 1 - HANDOFF_MAT_BLEND;
        const outEase = t <= matStart ? 0 : (t - matStart) / HANDOFF_MAT_BLEND;

        section.style.setProperty("--handoff-out", String(outEase));
        if (materialStage) {
          materialStage.style.visibility = outEase > 0 ? "visible" : "hidden";
          materialStage.style.opacity = String(outEase);
        }
        if (materialVideo && outEase > 0) {
          seekMaterial(outEase * 0.1);
        }
        if (pin) pin.style.setProperty("--stage-dim", "0");

        primeHandoff();
        seekHandoff(t);

        window.dispatchEvent(
          new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
        );
        window.dispatchEvent(
          new CustomEvent("le-cine-handoff", { detail: { active: true, progress: t } })
        );
        window.dispatchEvent(
          new CustomEvent("le-cine-material", {
            detail: {
              active: false,
              progress: 0,
              bridging: outEase > 0.001,
              t: outEase,
            },
          })
        );
      };

      const setMaterialPhase = (matP) => {
        const storyP = Math.max(0, Math.min(1, matP));

        clearHandoffStyles();
        applyCineLayer("material");

        cinePhase = "material";
        section.classList.remove(
          "ch--hero-active",
          "ch--fit-phase",
          "ch--handoff-phase",
          "ch--fit-handoff-xfade"
        );
        section.classList.add("ch--outro", "ch--material-phase");
        section.style.removeProperty("--fit-xfade");
        section.style.removeProperty("--handoff-xfade");
        section.style.removeProperty("--handoff-out");
        if (copy) copy.classList.remove("ch--copy-visible");
        chrome.forEach((el) => {
          el.style.opacity = "0";
        });
        if (fitSection) {
          fitSection.classList.remove("cf--live", "cf--raspad-active");
        }
        if (materialSection) materialSection.classList.remove("cm--past");

        window.dispatchEvent(
          new CustomEvent("le-cine-handoff", { detail: { active: false, progress: 1 } })
        );

        const state = getMatChapterState(storyP);
        if (materialStage) {
          materialStage.style.visibility = "visible";
          materialStage.style.opacity = "1";
          materialStage.style.clipPath = "none";
          materialStage.style.webkitClipPath = "none";
        }
        if (materialVideo) {
          materialVideo.style.transform = "scale(" + state.zoom.toFixed(3) + ")";
          materialVideo.style.filter = "";
          materialVideo.style.objectPosition =
            state.idx >= 2 ? "50% 50%" : state.idx === 0 ? "50% 40%" : "50% 48%";
        }
        seekMaterial(mapMatScrollToVideo(storyP));

        window.dispatchEvent(
          new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
        );
        window.dispatchEvent(
          new CustomEvent("le-cine-material", {
            detail: { active: true, progress: storyP, label: state.label },
          })
        );
      };

      const updateFromProgress = (progress) => {
        if (scrollPip) {
          scrollPip.style.setProperty("--scroll-progress", progress * 100 + "%");
        }
        if (isDragging || zoomedActive || !duration) return;
        targetTime = mapToTime(progress) * duration * config.videoEnd;
        scheduleSeek();
        if (counter) counter.textContent = fmtAngle(targetTime, duration);
      };

      restoreHeroChrome();

      /* === Unified phase — jedna funkcija drži sve slojeve sinhrono. === */
      const HANDOFF_FADE_IN = 0.22;
      const HANDOFF_FADE_OUT = 0.18;

      const setLayer = (el, op) => {
        if (!el) return;
        el.style.opacity = String(op);
        el.style.visibility = op > 0.005 ? "visible" : "hidden";
      };

      const applyUnifiedPhase = (p) => {
        if (!isUnified) return;
        const crossStart = heroShare * CROSS_AT;
        const fitZoneSpan = heroShare - crossStart + fitShare;
        const getFitScrollP = (globalP) => {
          if (globalP < crossStart) return 0;
          if (globalP > fitEnd) return 1;
          return (globalP - crossStart) / Math.max(fitZoneSpan, 0.0001);
        };
        let phase = "hero";
        let localP = 0;
        let heroOp = 0;
        let fitOp = 0;
        let anglesOp = 0;
        let handOp = 0;
        let matOp = 0;
        let chromeOp = 0;
        let dropIn = 0;

        if (p < crossStart) {
          phase = "hero";
          localP = p / Math.max(crossStart, 0.0001);
          heroOp = 1;
          chromeOp = 1;
          updateFromProgress(localP);
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", { detail: { active: false } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", {
              detail: { active: false, progress: 0 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", { detail: { active: false, progress: 0 } })
          );
        } else if (p < heroShare) {
          phase = "hero-outro";
          localP = (p - crossStart) / Math.max(heroShare - crossStart, 0.0001);
          heroOp = 1 - localP;
          fitOp = localP;
          chromeOp = Math.max(0, 1 - localP * 1.6);
          lockEndFrame();
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", {
              detail: { active: true, progress: getFitScrollP(p) },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", { detail: { active: false, progress: 0 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", { detail: { active: false } })
          );
        } else if (p <= fitEnd) {
          phase = "fit";
          localP = (p - heroShare) / Math.max(fitShare, 0.0001);
          fitOp = 1;
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", {
              detail: { active: true, progress: getFitScrollP(p) },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-angles", { detail: { active: false, progress: 0 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", { detail: { active: false, progress: 0 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", { detail: { active: false } })
          );
        } else if (p < anglesEnd && anglesShare > 0) {
          phase = "angles";
          localP = (p - fitEnd) / Math.max(anglesShare, 0.0001);
          anglesOp = 1;
          fitOp = 0;
          heroOp = 0;
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-angles", {
              detail: { active: true, progress: localP },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", { detail: { active: false, progress: 0 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", { detail: { active: false } })
          );
        } else if (p <= revealEnd && revealShare > 0) {
          phase = "reveal";
          localP = (p - anglesEnd) / Math.max(revealShare, 0.0001);
          dropIn = localP > 0.86 ? Math.min(1, (localP - 0.86) / 0.14) : 0;
          const revealTail =
            localP > 0.76 ? Math.max(0, 1 - (localP - 0.76) / 0.24) : 1;
          anglesOp = revealTail * (1 - dropIn);
          fitOp = 0;
          heroOp = 0;
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-angles", {
              detail: { active: anglesOp > 0.02, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", {
              detail: { active: dropIn < 0.55, progress: localP },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", {
              detail: {
                active: dropIn > 0.01,
                fade: dropIn,
                progress: 0,
              },
            })
          );
        } else if (p <= dropEnd && dropShare > 0) {
          phase = "drop";
          localP = (p - revealEnd) / Math.max(dropShare, 0.0001);
          dropIn = 1;
          anglesOp = 0;
          fitOp = 0;
          heroOp = 0;
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-angles", {
              detail: { active: false, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", {
              detail: { active: false, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", {
              detail: { active: true, fade: 1, progress: localP },
            })
          );
        } else if (false && p < handoffEnd && handoffShare > 0) {
          phase = "handoff";
          localP = (p - fitEnd) / Math.max(handoffShare, 0.0001);
          handOp = 1;
          if (localP < HANDOFF_FADE_IN) {
            const fadeIn = localP / HANDOFF_FADE_IN;
            fitOp = Math.max(0, 1 - fadeIn * 2);
            handOp = fadeIn;
          } else if (localP > 1 - HANDOFF_FADE_OUT) {
            const fadeOut =
              (localP - (1 - HANDOFF_FADE_OUT)) / HANDOFF_FADE_OUT;
            /* Ruka prvo brzo nestane, materijal preuzima ceo ekran sam. */
            handOp = Math.max(0, 1 - fadeOut * 3);
            matOp = fadeOut;
          }
          primeHandoff();
          seekHandoff(localP);
          if (matOp > 0.02 && materialVideo) seekMaterial(matOp * 0.1);
          window.dispatchEvent(
            new CustomEvent("le-cine-fit", { detail: { active: false, progress: 1 } })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-handoff", {
              detail: { active: true, progress: localP },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-material", {
              detail: { active: false, progress: 0, bridging: matOp > 0.02, t: matOp },
            })
          );
        } else if (materialShare > 0) {
          phase = "material";
          localP = (p - handoffEnd) / Math.max(materialShare, 0.0001);
          matOp = 1;
          const state = getMatChapterState(localP);
          if (materialVideo) {
            materialVideo.style.transform =
              "scale(" + state.zoom.toFixed(3) + ")";
            materialVideo.style.objectPosition =
              state.idx >= 2 ? "50% 50%" : state.idx === 0 ? "50% 40%" : "50% 48%";
          }
          seekMaterial(mapMatScrollToVideo(localP));
          window.dispatchEvent(
            new CustomEvent("le-cine-handoff", {
              detail: { active: false, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-material", {
              detail: { active: true, progress: localP, label: state.label },
            })
          );
        }

        setLayer(heroWrap, heroOp);
        if (productStack) {
          const stackOp = heroOp;
          productStack.style.display = stackOp > 0.005 ? "" : "none";
          productStack.style.opacity = "1";
          productStack.style.visibility = "visible";
          productStack.style.pointerEvents = stackOp > 0.5 ? "" : "none";
        }

        chrome.forEach((el) => {
          if (el.classList.contains("ch__bracket")) return;
          if (copy && el === copy) return;
          el.style.opacity = String(chromeOp);
        });
        if (copy) {
          if (phase === "hero") {
            copy.classList.add("ch--copy-visible");
            copy.style.opacity = "1";
          } else if (phase === "hero-outro") {
            copy.classList.add("ch--copy-visible");
            copy.style.opacity = String(Math.max(0, 1 - localP * 1.85));
          } else {
            copy.classList.remove("ch--copy-visible");
            copy.style.opacity = "";
          }
        }

        section.classList.toggle("ch--hero-active", phase === "hero");
        section.classList.toggle("ch--outro", phase !== "hero");
        section.classList.toggle("ch--fit-phase", phase === "fit");
        section.classList.toggle("ch--angles-phase", phase === "angles");
        section.classList.toggle("ch--reveal-phase", phase === "reveal");
        section.classList.toggle("ch--drop-phase", phase === "drop");

        /* Toggle the CSS-fixed pin overlay — pin is visible during the
           hero and hero-outro phases, hidden otherwise. Mirrors the
           pattern used by fit/angles/reveal/drop sections which already
           work on mobile. See `.le-cine .ch__pin--live` in CSS. */
        if (pin) {
          const heroVisible = phase === "hero" || phase === "hero-outro";
          pin.classList.toggle("ch__pin--live", heroVisible);
        }

        if (fitSection) {
          const fitPin = fitSection.querySelector(".cf__pin");
          const fitChrome = fitSection.querySelectorAll(".cf__chrome");
          if (phase === "hero-outro" || phase === "fit") {
            const fitP = getFitScrollP(p);
            const fitPinOp =
              fitP < 0.035 ? fitP / 0.035 : 1;
            setLayer(fitPin, fitPinOp);
            fitSection.classList.toggle("cf--live", fitPinOp > 0.02);
            fitSection.classList.toggle("cf--raspad-active", fitP > 0.04);
            fitSection.classList.remove("cf--past");
            const fitTextOp = Math.min(1, Math.max(0, (fitP - 0.03) / 0.32));
            fitChrome.forEach((el) => {
              el.style.opacity =
                phase === "fit" && fitTextOp >= 0.98 ? "" : String(fitTextOp);
            });
          } else {
            setLayer(fitPin, 0);
            fitSection.classList.remove("cf--live", "cf--raspad-active");
            fitChrome.forEach((el) => {
              el.style.opacity = "";
            });
            if (phase === "angles") fitSection.classList.add("cf--past");
            else fitSection.classList.remove("cf--past");
          }
        }
        if (anglesSection) {
          const anglesPin = anglesSection.querySelector(".cag__pin");
          if ((phase === "angles" || phase === "reveal") && anglesOp > 0.02) {
            anglesSection.classList.add("cag--live");
            anglesSection.classList.remove("cag--past");
            setLayer(anglesPin, anglesOp);
          } else {
            anglesSection.classList.remove("cag--live");
            anglesSection.classList.remove("cag--past");
            setLayer(anglesPin, 0);
          }
        }
        if (revealSection) {
          if (phase === "reveal" && dropIn < 0.45) {
            revealSection.classList.add("cvr--live");
            revealSection.classList.remove("cvr--past");
          } else {
            revealSection.classList.remove("cvr--live");
          }
        }
        if (dropSection) {
          if (phase === "drop" || dropIn > 0.01) {
            dropSection.classList.add("cdp--live", "is-visible");
            dropSection.classList.remove("cdp--past", "cdp--static");
            dropSection.style.setProperty(
              "--cdp-fade",
              String(phase === "drop" ? 1 : dropIn)
            );
          } else {
            dropSection.classList.remove("cdp--live");
          }
        }

        cinePhase = phase;
      };

      const syncPhaseFromScroll = () => {
        if (!isUnified) return;
        const p = mainScrollST ? mainScrollST.progress : 0;
        applyUnifiedPhase(p);
      };

      const mainScrollST = ScrollTrigger.create({
        trigger: track,
        start: "top top",
        end: "bottom bottom",
        scrub: SCRUB,
        /* No `pin:` option here on purpose. GSAP pin (both fixed and
           transform types) breaks on mobile momentum scroll — the hero
           element visually scrolls off even though pin is "active". The
           other unified sections (fit/angles/reveal/drop) use plain CSS
           `position: fixed; inset: 0;` overlays and that works fine on
           mobile, so hero now does the same: see `.le-cine .ch__pin`
           in cinematic-hero.css. We toggle `.ch__pin--live` from JS based
           on the active phase to show/hide. Track height still provides
           the scroll length naturally (no pinSpacing needed). */
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const p = self.progress;

          if (isUnified) {
            applyUnifiedPhase(p);
            return;
          }

          const scrubP = scrubRatio >= 1 ? p : p / scrubRatio;
          if (scrubP < CROSS_AT) {
            applyOutro(0);
            if (rotatorWrap) gsap.set(rotatorWrap, { y: 0, scale: 1 });
            updateFromProgress(scrubP / CROSS_AT);
          } else {
            lockEndFrame();
            const crossP = (scrubP - CROSS_AT) / (1 - CROSS_AT);
            if (rotatorWrap) gsap.set(rotatorWrap, { y: 0, scale: 1 });
            applyOutro(crossP);
          }
        },
        onLeaveBack: () => {
          cinePhase = "hero";
          if (isUnified) {
            applyUnifiedPhase(0);
          } else {
            resetStack();
          }
        },
        onLeave: () => {
          section.classList.add("ch--pin-done");
          const leCine = document.querySelector(".le-cine");
          if (leCine) leCine.classList.add("le-cine--done");
          if (fitSection) {
            fitSection.classList.add("cf--past");
            fitSection.classList.remove("cf--live", "cf--raspad-active");
          }
          if (anglesSection) {
            anglesSection.classList.add("cag--past");
            anglesSection.classList.remove("cag--live");
          }
          if (revealSection) {
            revealSection.classList.add("cvr--past");
            revealSection.classList.remove("cvr--live");
          }
          if (dropSection) {
            dropSection.classList.remove("cdp--live", "cdp--past");
            dropSection.classList.add("cdp--static", "is-visible");
          }
          window.dispatchEvent(
            new CustomEvent("le-cine-reveal", {
              detail: { active: false, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-angles", {
              detail: { active: false, progress: 1 },
            })
          );
          window.dispatchEvent(
            new CustomEvent("le-cine-drop", {
              detail: { active: true, static: true, fade: 1, progress: 1 },
            })
          );
        },
        onEnterBack: () => {
          section.classList.remove("ch--pin-done");
          const leCine = document.querySelector(".le-cine");
          if (leCine) leCine.classList.remove("le-cine--done");
          if (dropSection) {
            dropSection.classList.remove("cdp--static");
          }
          syncPhaseFromScroll();
        },
      });

      ScrollTrigger.refresh();
      syncPhaseFromScroll();

      /* Depth parallax — background layers move at different speeds on scroll */
      const depthLayers = section.querySelectorAll("[data-depth-layer]");
      depthLayers.forEach((el) => {
        const y = parseFloat(el.getAttribute("data-depth-y")) || 20;
        const x = parseFloat(el.getAttribute("data-depth-x")) || 0;
        const scale = parseFloat(el.getAttribute("data-depth-scale")) || 0;
        gsap.fromTo(
          el,
          { y: 0, x: 0, scale: 1 },
          {
            y,
            x,
            scale: 1 + scale,
            ease: "none",
            scrollTrigger: {
              trigger: track,
              start: "top top",
              end: () => "+=" + scrubEndPx(),
              scrub: SCRUB,
            },
          }
        );
      });

      /* Scale animation on the VIDEO (not the wrapper) so the wrapper can keep
         mix-blend-mode: lighten without forming a stacking context. */
      if (video) {
        gsap.fromTo(
          video,
          { scale: 0.92 },
          {
            scale: 1.04,
            ease: "none",
            scrollTrigger: {
              trigger: track,
              start: "top top",
              end: () => "+=" + scrubEndPx(),
              scrub: SCRUB,
            },
          }
        );
      }

      if (copy) {
        const copyPathMq = window.matchMedia("(min-width: 721px)");
        let copyPathST = null;

        gsap.fromTo(
          copy,
          { opacity: 0, y: 36 },
          {
            opacity: 1,
            y: 0,
            duration: 1.1,
            ease: "power3.out",
            delay: 0.15,
            onComplete: restoreHeroChrome,
          }
        );

        const getCopyYStops = () => {
          const stage = pin || section;
          const h = stage.offsetHeight || window.innerHeight;
          const copyH = copy.offsetHeight || 220;
          const bottomPad =
            parseFloat(getComputedStyle(copy).bottom) || h * 0.08;
          const topPad = Math.max(88, h * 0.11);
          const midY = -(h * 0.5 - copyH * 0.5 - bottomPad);
          const endY = -(h - topPad - copyH - bottomPad);
          return { midY, endY };
        };

        const yAtProgress = (progress, midY, endY) => {
          if (progress <= 0.5) {
            return gsap.utils.interpolate(0, midY, progress / 0.5);
          }
          return gsap.utils.interpolate(midY, endY, (progress - 0.5) / 0.5);
        };

        const bindCopyPath = () => {
          if (copyPathST) {
            copyPathST.kill();
            copyPathST = null;
          }
          if (!copyPathMq.matches) {
            gsap.set(copy, { x: 0, y: 0 });
            return;
          }
          /* Desktop: bottom-left → left center (50%) → top-left (100%) */
          copyPathST = ScrollTrigger.create({
            trigger: track,
            start: "top top",
            end: "bottom bottom",
            scrub: SCRUB,
            invalidateOnRefresh: true,
            onUpdate: (self) => {
              const { midY, endY } = getCopyYStops();
              const heroP = getHeroScrollP(self.progress);
              const y = yAtProgress(heroP, midY, endY);
              gsap.set(copy, { x: 0, y });
            },
          });
        };

        bindCopyPath();
        copyPathMq.addEventListener("change", () => {
          gsap.set(copy, { x: 0, y: 0 });
          bindCopyPath();
          ScrollTrigger.refresh();
        });
      }

      /* Headline morph — three stages crossfade across scroll progress.
         Stage 0 dominant 0%–33%, stage 1 dominant 33%–66%, stage 2 dominant 66%–100%.
         Each stage also drifts upward subtly as it fades out for cinematic feel. */
      if (headingStages && headingStages.length === 3) {
        const stages = Array.from(headingStages);
        const stageFadeIn = 0.08;
        const computeOpacity = (progress, stageIdx) => {
          const center = stageIdx === 0 ? 0.16 : stageIdx === 1 ? 0.5 : 0.84;
          const width = 0.22;
          const d = Math.abs(progress - center);
          if (d <= width - stageFadeIn) return 1;
          if (d >= width) return 0;
          return 1 - (d - (width - stageFadeIn)) / stageFadeIn;
        };
        const computeY = (progress, stageIdx) => {
          const center = stageIdx === 0 ? 0.16 : stageIdx === 1 ? 0.5 : 0.84;
          return (progress - center) * 60;
        };
        const morphST = ScrollTrigger.create({
          trigger: track,
          start: "top top",
          end: "bottom bottom",
          scrub: SCRUB,
          onUpdate: (self) => {
            const heroFrac = scrubVh / Math.max(totalVh, 1);
            if (self.progress > heroFrac * 1.02) {
              stages.forEach((el) => {
                el.style.opacity = "0";
              });
              return;
            }
            const p = getHeroScrollP(self.progress);
            stages.forEach((el, i) => {
              const op = computeOpacity(p, i);
              const y = computeY(p, i);
              el.style.opacity = op.toFixed(3);
              el.style.transform = `translateY(${y.toFixed(1)}px)`;
            });
          },
        });
        morphST.refresh();
      }

      ScrollTrigger.refresh();
      syncPhaseFromScroll();
    };

    window.addEventListener(
      "resize",
      () => { if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh(); },
      { passive: true }
    );

    /* === Hotspot zoom controller ===
       Click on a hotspot:
         - lock page scroll
         - pin video to that hotspot's frame
         - apply scale transform with the hotspot's screen coords as origin
         - reveal the detail panel
       Close (X / Esc / outside click): reverse everything. */

    const openZoom = (hotspot) => {
      if (!rotatorWrap || !video || !duration) return;
      zoomedActive = hotspot;
      const frame = parseInt(hotspot.getAttribute("data-frame"), 10) || 0;
      const scale = parseFloat(hotspot.getAttribute("data-zoom-scale")) || 2.4;
      const x = parseFloat(hotspot.style.getPropertyValue("--hx")) || 50;
      const y = parseFloat(hotspot.style.getPropertyValue("--hy")) || 50;
      const title = hotspot.getAttribute("data-detail-title") || "";
      const text = hotspot.getAttribute("data-detail-text") || "";

      try { video.currentTime = (frame / 24); } catch (_) {}
      targetTime = video.currentTime;

      rotatorWrap.style.setProperty("--zoom-scale", scale);
      rotatorWrap.style.setProperty("--zoom-x", x + "%");
      rotatorWrap.style.setProperty("--zoom-y", y + "%");
      rotatorWrap.classList.add("is-zoomed");

      if (detailPanel) {
        if (detailTitleEl) detailTitleEl.textContent = title;
        if (detailTextEl) detailTextEl.textContent = text;
        detailPanel.classList.add("is-open");
        detailPanel.setAttribute("aria-hidden", "false");
      }

      lockScroll();
    };

    const closeZoom = () => {
      if (!zoomedActive) return;
      zoomedActive = null;
      if (rotatorWrap) rotatorWrap.classList.remove("is-zoomed");
      if (detailPanel) {
        detailPanel.classList.remove("is-open");
        detailPanel.setAttribute("aria-hidden", "true");
      }
      unlockScroll();
    };

    hotspots.forEach((h) => {
      h.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openZoom(h);
      });
    });

    if (detailClose) {
      detailClose.addEventListener("click", (e) => {
        e.preventDefault();
        closeZoom();
      });
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && zoomedActive) closeZoom();
    });

    /* Click on the zoomed rotator (outside the detail panel) also closes. */
    if (rotatorWrap) {
      rotatorWrap.addEventListener("click", (e) => {
        if (zoomedActive && !e.target.closest("[data-hotspot]")) closeZoom();
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-cinematic-hero]").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const sec = e.target.querySelector("[data-cinematic-hero]");
    if (sec) initHero(sec);
  });
})();
/* bust 1779473871 */
